export default __webpack_public_path__ + "static/media/aerator.1d866b8b.png";